import { call, put, takeLatest, select } from 'redux-saga/effects';
import accountApi from '../../api/account';

import Account from '../../models/SFModels/Account';

import { FETCH_SALESFORCE_DATA } from '../DataServices/SFDataService/actions';
import { FRONT_INFORMATIONS_READY } from '../DataServices/SFDataService/actions';

import * as Actions from './actions';

export function* fetchAccount(action) {
  const account = yield call(accountApi.fetchAccount, action.accountId);
  yield put(Actions.accountDataTerminateLoading(account));
}

export function* populateAccount(action) {
  let account = yield select(state => state.account);
  if (action.customerInformations !== null && action.customerDetails !== null) {
    if (account === null) {
      account = new Account(
        action.customerInformations.getId(),
        action.customerInformations.getPhone(),
        action.customerInformations.getTypoCategory(),
        action.customerInformations.getTypoType(),
        action.customerDetails.getEstablishmentArea(),
      );
    } else {
      account = account
        .clone()
        .setId(action.customerInformations.getId())
        .setPhone(action.customerInformations.getPhone())
        .setTypoCategory(action.customerInformations.getTypoCategory())
        .setTypoType(action.customerInformations.getTypoType())
        .setEstablishmentArea(action.customerDetails.getEstablishmentArea());
    }
  }

  yield put(Actions.accountUpdated(account));
}

export function* accountListener() {
  yield takeLatest(FETCH_SALESFORCE_DATA, fetchAccount);
  yield takeLatest(FRONT_INFORMATIONS_READY, populateAccount);
}



// WEBPACK FOOTER //
// ./src/services/SFAccountService/saga.js